import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, useLocation } from "react-router-dom";
import "./App.scss";
import { Header } from "./Components/Header";
import { MisHeader } from "./Components/MisHeader";
import { useAuth } from "./contexts/auth";
import { useMisAuth } from "./contexts/misAuth";

function App() {
  const { pathname } = useLocation();
  const { user, onLogout } = useAuth();
  // Check if current path is MIS-related route
  const isMisRoute = pathname.startsWith("/mis");
  const { misUser, onMisLogout } = useMisAuth();

  return (
    <div className="App">
      {pathname !== "/" &&
        (isMisRoute ? (
          <MisHeader user={misUser} onLogout={onMisLogout} />
        ) : (
          <Header user={user} onLogout={onLogout} />
        ))}
      <main>
        <Outlet />
      </main>
      <Toaster position="bottom-center" reverseOrder={false} />
    </div>
  );
}

export default App;
